import {Injectable} from '@angular/core';
import {RequesterService} from '../../../services/requester.service';
import {NavController} from '@ionic/angular';
import {EventsService} from '../../../services/events.service';
import {CoachModel, CoachSimpleModel, TemplateCoachModel, TemplateCoachSimpleModel} from '../models/coach.model';
import {CoachAvailabilityModel, UpdateCoachAvailabilityModel} from '../models/availability.model';
import {CoachSessionModel} from '../models/session.model';
import {RequesterResponseModel} from '../../../services/models/requester.model';
import {ReviewReportFormModel, ReviewReportOne2OneFormModel} from '../../review/models/review.model';
import {CoachingJourneyDelegateFormModel} from '../models/journey.model';

@Injectable({
    providedIn: 'root'
})
export class CoachService {
    __coachCache: any = {};
    coachesList: CoachSimpleModel[] = null;

    constructor(
        private event: EventsService,
        private navCtrl: NavController,
        private requesterService: RequesterService
    ) {
    }

    getCoach(template_coach_id: number): Promise<TemplateCoachModel> {
        return this.requesterService.get('getCoach', {template_coach_id})
            .then(data => {
                return data.result;
            })
            .catch(e => {
                console.log('Error getCoach >> ', e);
                return null;
            });
    }

    getMyCoachesList(): Promise<TemplateCoachSimpleModel[]> {
        return this.requesterService.get('getMyCoachesList')
            .then(data => {
                this.coachesList = data.result;
                return this.coachesList;
            })
            .catch(e => {
                console.log('Error getMyCoachesList >> ', e);
                return null;
            });
    }

    getMyCoachAvailabilityList(startTime: string, endTime: string): Promise<CoachAvailabilityModel[]> {
        return this.requesterService.get('getMyCoachAvailabilityList', {startTime, endTime})
            .then(data => {
                return data.result;
            })
            .catch(e => {
                console.log('Error getMyCoachAvailabilityList >> ', e);
                return null;
            });
    }

    getMyCoachAppointmentsList(): Promise<CoachSessionModel[]> {
        return this.requesterService.get('getMyCoachAppointmentsList')
            .then(data => {
                return data.result;
            })
            .catch(e => {
                console.log('Error getMyCoachAppointmentsList >> ', e);
                return null;
            });
    }

    getCoachSessionInfo(sessionId): Promise<CoachSessionModel> {
        return this.requesterService.get('getCoachSessionInfo', {'session_id': sessionId})
            .then(data => {
                return data.result;
            })
            .catch(e => {
                console.log('Error getCoachSessionInfo >> ', e);
                return null;
            });
    }


    getMyCoachRequestsList(): Promise<CoachSessionModel[]> {
        return this.requesterService.get('getMyCoachRequestsList')
            .then(data => {
                return data.result;
            })
            .catch(e => {
                console.log('Error getMyCoachRequestsList >> ', e);
                return null;
            });
    }

    getCoachAvailabilityList(template_coach_id: number, startTime: string, endTime: string): Promise<CoachAvailabilityModel[]> {
        return this.requesterService.get('getCoachAvailabilityList', {template_coach_id, startTime, endTime})
            .then(data => {
                return data.result;
            })
            .catch(e => {
                console.log('Error getCoachAvailabilityList >> ', e);
                return null;
            });
    }

    addMyCoachAvailability(date: string): Promise<CoachAvailabilityModel> {
        return this.requesterService.post('addMyCoachAvailability', {date})
            .then(data => {
                return data.result;
            })
            .catch(e => {
                console.log('Error addMyCoachAvailability >> ', e);
                return null;
            });
    }

    updateMyCoachAvailability(data: UpdateCoachAvailabilityModel): Promise<CoachAvailabilityModel[]> {
        return this.requesterService.post('updateMyCoachAvailability', data)
            .then(data => {
                return data.result;
            })
            .catch(e => {
                console.log('Error updateMyCoachAvailability >> ', e);
                return null;
            });
    }

    deleteMyCoachAvailability(id: number): Promise<RequesterResponseModel> {
        return this.requesterService.post('deleteMyCoachAvailability', {id})
            .then(data => {
                return data.result;
            })
            .catch(e => {
                console.log('Error deleteMyCoachAvailability >> ', e);
                return null;
            });
    }

    addCoachAppointment(availability_id: number, title_id: number, meeting_type: string): Promise<CoachSessionModel> {
        return this.requesterService.post('addCoachAppointment', {availability_id, title_id, meeting_type})
            .then(data => {
                return data.result;
            })
            .catch(e => {
                console.log('Error addCoachAppointment >> ', e);
                return null;
            });
    }

    confirmCoachRequest(session_id: number): Promise<RequesterResponseModel> {
        return this.requesterService.post('confirmCoachRequest', {session_id})
            .then(data => {
                return data.result;
            })
            .catch(e => {
                console.log('Error confirmCoachRequest >> ', e);
                return null;
            });
    }

    cancelCoachAppointment(session_id: number, reason: string): Promise<RequesterResponseModel> {
        return this.requesterService.post('cancelCoachAppointment', {session_id, reason})
            .then(data => {
                return data.result;
            })
            .catch(e => {
                console.log('Error cancelCoachAppointment >> ', e);
                return null;
            });
    }

    rejectCoachRequest(session_id: number, reason: string): Promise<RequesterResponseModel> {
        return this.requesterService.post('rejectCoachRequest', {session_id, reason})
            .then(data => {
                return data.result;
            })
            .catch(e => {
                console.log('Error rejectCoachRequest >> ', e);
                return null;
            });
    }

    getUserCoachingJourneyForm(delegate_id: number = 0): Promise<CoachingJourneyDelegateFormModel> {
        return this.requesterService.get('getUserCoachingJourneyForm', {delegate_id})
            .then(data => {
                if (!!data.result) {
                    return data.result;
                }
                return null;
            })
            .catch(e => {
                console.log('Error getUserCoachingJourneyFormAPI2 >> ', e);
                return null;
            });
    }

    saveUserCoachingJourneyForm(report): Promise<CoachingJourneyDelegateFormModel|RequesterResponseModel> {
        return this.requesterService.post('saveUserCoachingJourneyForm', report)
            .then(data => {
                if (!!data.result) {
                    this.event.publish('coaching-journey.saveUserCoachingJourneyForm');
                    return data.result;
                }
                throw "Response structure is not valid";
            })
            .catch(e => {
                console.log('Error saveUserCoachingJourneyForm >> ', e);
            });
    }

    saveMyCoachSessionFeedback(session_id, feedback): Promise<RequesterResponseModel> {
        return this.requesterService.post('saveMyCoachSessionFeedback', {session_id, feedback})
            .then(data => {
                if (!!data.result) {
                    this.event.publish('coach.saveMyCoachSessionFeedback');
                    return data.result;
                }
                throw "Response structure is not valid";
            })
            .catch(e => {
                console.log('Error saveMyCoachSessionFeedback >> ', e);
            });
    }

    updateUserCoachingJourneyGoalStatus(goal_id: number, status: boolean): Promise<RequesterResponseModel> {
        return this.requesterService.post('updateUserCoachingJourneyGoalStatus', {goal_id, status})
            .then(data => {
                if (!!data.result) {
                    this.event.publish('coaching-journey.updateUserCoachingJourneyGoalStatus');
                    return data.result;
                }
                throw "Response structure is not valid";
            })
            .catch(e => {
                console.log('Error updateUserCoachingJourneyGoalStatus >> ', e);
            });
    }

    deleteUserCoachingJourneyGoal(goal_id: number): Promise<RequesterResponseModel> {
        return this.requesterService.post('deleteUserCoachingJourneyGoal', {goal_id})
            .then(data => {
                if (!!data.result) {
                    this.event.publish('coaching-journey.deleteUserCoachingJourneyGoal');
                    return data.result;
                }
                throw "Response structure is not valid";
            })
            .catch(e => {
                console.log('Error deleteUserCoachingJourneyGoal >> ', e);
            });
    }


}
